/**
 * Deliveries tab gate.
 *
 * Delivery dispatch (routes, drivers, stops) was pulled from the product in
 * July 2026. It is back for the Testing Store ONLY while it is re-checked
 * end to end. Per-STORE allowlist, like phoneAgentAccess.js: nothing in
 * dashboardTabRestrictions (JSON or plan config) can turn it on for a live
 * store. A code commit is the only way to widen it.
 */

const DELIVERIES_ENABLED_STORE_IDS = new Set([
  '1e31fec9-882d-44b4-b870-1899f759764b', // Testing Store
]);

/**
 * @param {string | null | undefined} storeId
 * @returns {boolean}
 */
export function isDeliveriesEnabledForStore(storeId) {
  if (!storeId) return false;
  return DELIVERIES_ENABLED_STORE_IDS.has(storeId);
}
